<ion-chip outline="true" disabled="true" [ngClass]="{ highlighted: isActive }">
  <ng-content></ng-content>
</ion-chip>
